import { format, subDays } from "date-fns";

/**
 * @see: https://www.npmjs.com/package/@dpa-id-components/ui-date-range-picker
 * @returns {Object} A set of properties that should be set on a date picker instance
 */

export const localeData = {
  direction: "ltr",
  format: "dd.mm.yyyy",
  separator: " – ",
  applyLabel: "Anwenden",
  cancelLabel: "Abbrechen",
  weekLabel: "W",
  customRangeLabel: "Custom Range",
  // Need to prevent duplicate keys, therfore no single characters possible.
  daysOfWeek: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  monthNames: [
    "Jan",
    "Feb",
    "Mrz",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  firstDay: 1
};

export const createRanges = () => {
  const today = new Date();

  const yesterday = subDays(new Date(), 1);

  const lastFortyDays = subDays(new Date(), 40);

  const lastWeek = subDays(new Date(), 7);

  return {
    "Alles (Letzte 40 Tage)": [lastFortyDays, today],
    Heute: [today, today],
    "Seit gestern": [yesterday, today],
    "Letzte 7 Tage": [lastWeek, today]
  };
};

export const createDesktopDatePickerProps = () => {
  return {
    opens: "right",
    autoApply: false,
    appendToBody: false,
    showDropdowns: true,
    localeData,
    ranges: createRanges()
  };
};

export const createMobileDatePickerProps = () => {
  return {
    opens: "right",
    autoApply: false,
    appendToBody: false,
    showDropdowns: true,
    localeData,
    singleDatePicker: "range",
    ranges: createRanges()
  };
};

export const formatDateRange = (
  startDate: Date | null,
  endDate: Date | null
) => {
  const DATE_FORMAT_STR = "DD.MM.YYYY";

  if (!!startDate && !!endDate) {
    return `${format(startDate, DATE_FORMAT_STR)} – ${format(
      endDate,
      DATE_FORMAT_STR
    )}`;
  }

  return "";
};

export default {
  createDesktopDatePickerProps,
  createMobileDatePickerProps,
  formatDateRange
};
